import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const MenuBurger = createSvgIcon(
  <path d="M24 2.25H0V4.5h24V2.25ZM0 19.5h24v2.25H0V19.5Zm0-8.625h24v2.25H0v-2.25Z" />,
  'MenuBurger'
);

export { MenuBurger };